import { render, staticRenderFns } from "./DividendsIndicator.vue?vue&type=template&id=4c7122aa&scoped=true"
import script from "./DividendsIndicator.vue?vue&type=script&lang=js"
export * from "./DividendsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7122aa",
  null
  
)

export default component.exports